import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import HeaderOne from '../../header/HeaderOne';
import FooterOne from '../../footer/FooterOne';
import Head from '../../components/Head';

/* ---------- tiny presentation components ---------- */
const Hero = () => (
  <header className="hero">
    <p>
      Send SMS from your own devices & SIMs via our&nbsp;
      <strong>API</strong>, <strong>no-code tools</strong>, and{' '}
      <strong>integrations</strong>. No carrier forms, no A2P hoops—just lower cost
      messaging.
    </p>
  </header>
);

const StepCard = ({ n, title, children }) => (
  <article className="step">
    <span className="badge">{n}</span>
    <h2>{title}</h2>
    <p>{children}</p>
  </article>
);

const CTA = ({ onClick }) => (
  <section className="cta" style={{ background: 'none' }}>
    <h2>Ready to start?</h2>
    <p>Join TextLink and get 300 free messages.</p>
    <button onClick={onClick}>
      Sign Up
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
        <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" />
      </svg>
    </button>
  </section>
);

/* ---------- page ---------- */
export default function HowItWorks() {
  const navigate = useNavigate();

  return (
    <>
      <Head title="How TextLink Works" />
      <HeaderOne />

      <main className="how">
        <div className="container">
          <Hero />

          <div className="steps">
            <StepCard n="1" title="Device setup">
              <Link to="/signup">Register</Link> (300 free SMS), install the
              TextLink Android gateway, pop in a SIM, connect Wi-Fi—done.
            </StepCard>

            <StepCard n="2" title="Sub-accounts">
              Add teammates and assign SIMs inside the dashboard.
            </StepCard>

            <StepCard n="3" title="Integrations">
              Use no-code bulk sender or hit the two-way&nbsp;API for OTP, reminders,
              and more.
            </StepCard>
          </div>

          <CTA onClick={() => navigate('/signup')} />
        </div>
      </main>

      <FooterOne />

      {/* ---------- styles ---------- */}
      <style jsx>{`
        /* layout */
        .how {
          padding: 12rem 0 3rem;
          background: #f9fbff;
        }
        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1.25rem;
        }

        /* hero */
        .hero {
          text-align: center;
          margin-bottom: 3.5rem;
        }
        .hero h1 {
          font-size: clamp(2rem, 4vw + 0.5rem, 2.75rem);
          font-weight: 800;
          margin-bottom: 1rem;
        }
        .hero p {
          font-size: clamp(1rem, 1vw + 0.5rem, 1.15rem);
          color: #475569;
          max-width: 42rem;
          margin: 0 auto;
          line-height: 1.65;
        }

        /* steps */
        .steps {
          display: grid;
          gap: 1.5rem;
        }
        @media (min-width: 1024px) {
          .steps {
            grid-template-columns: repeat(3, 1fr);
          }
        }
        .step {
          background: #fff;
          border: 1px solid #e2e8f0;
          border-radius: 1rem;
          padding: 1.75rem;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.04);
          transition: transform 0.2s ease;
        }
        .step:hover {
          transform: translateY(-3px);
        }
        .badge {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 2.25rem;
          height: 2.25rem;
          border-radius: 0.6rem;
          background: #3b82f6;
          color: #fff;
          font-weight: 700;
          margin-bottom: 1rem;
        }
        .step h2 {
          font-size: 1.25rem;
          margin: 0 0 0.75rem;
          color: #0f172a;
        }
        .step p {
          font-size: 0.95rem;
          color: #64748b;
          line-height: 1.6;
        }
        a {
          color: #3b82f6;
          font-weight: 600;
          text-decoration: none;
        }
        a:hover {
          text-decoration: underline;
        }

        /* cta */
        .cta {
          text-align: center;
          margin-top: 3.5rem;
          padding: 2.5rem 1.5rem;
          border-radius: 1rem;
        }
        .cta h2 {
          font-size: 1.6rem;
          margin: 0 0 0.75rem;
        }
        .cta p {
          color: #475569;
          margin: 0 0 1.75rem;
        }
        .cta button {
          background: #2563eb;
          color: #fff;
          border: 0;
          padding: 0.85rem 1.8rem;
          border-radius: 0.6rem;
          font-weight: 600;
          cursor: pointer;
          display: inline-flex;
          gap: 0.5rem;
          align-items: center;
          transition: background 0.25s ease;
        }
        .cta button:hover {
          background: #1e40af;
        }
      `}</style>
    </>
  );
}
